import header from "./frau-kalkulation-taschenrechner-wohnfläche.webp";
import section1 from "./immobilie-flur.webp";
import section2 from "./attic-built-in-furniture.webp";
import section3 from "./unterschiede-tabelle.png";
import section4 from "./wohnflaechenberechnung-raumhoehen.png";
import section5 from "./immobilie-indoorpool.webp";
import section6 from "./immobilie-wintergarten.webp";
import section7 from "./balkon-terasse.webp";
import section8 from "./bemasster-grundriss-mit-architektenstempel.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
};
